import React from "react";
import { Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { ROOT } from "./CONSTANTS";

export const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div style={{ textAlign: "center", marginTop: "100px" }}>
      <Typography variant="h2">404: Page Not Found!</Typography>
      <Button
        variant="contained"
        onClick={() => navigate(ROOT)}
        style={{ marginTop: "20px" }}
      >
        Go Home
      </Button>
    </div>
  );
};
